/**
 * Utilitário para validação de senha forte
 */

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

/**
 * Valida se uma senha atende aos critérios de segurança
 * @param password - Senha a ser validada
 * @returns Objeto com isValid (boolean) e errors (array de strings)
 */
export function validatePasswordStrength(
  password: string
): PasswordValidationResult {
  const errors: string[] = [];

  if (!password || password.length < 8) {
    errors.push("A senha deve ter pelo menos 8 caracteres");
  }

  if (!/[a-z]/.test(password)) {
    errors.push("A senha deve conter pelo menos uma letra minúscula");
  }

  if (!/[A-Z]/.test(password)) {
    errors.push("A senha deve conter pelo menos uma letra maiúscula");
  }

  if (!/[0-9]/.test(password)) {
    errors.push("A senha deve conter pelo menos um número");
  }

  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push(
      "A senha deve conter pelo menos um caractere especial (!@#$%^&*()_+-=[]{}|;':\",./<>?)"
    );
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

/**
 * Retorna uma mensagem de erro formatada para validação de senha
 * @param password - Senha a ser validada
 * @returns Mensagem de erro ou null se válida
 */
export function getPasswordValidationError(
  password: string
): string | null {
  const validation = validatePasswordStrength(password);

  if (!validation.isValid) {
    return validation.errors.join(". ");
  }

  return null;
}

